module.exports = __webpack_public_path__ + "img/introduceImg.8172f604.png";